(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ealg-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('contact-form');
  if (!form || form.dataset.ealgInit) return;
  form.dataset.ealgInit = 'true';

  var initEmailJs = function () {
    if (window.emailjs && !window.__ealgEmailJsInit) {
      window.emailjs.init('user_4OetZi1NbTB2bj1Ho0j1W');
      window.__ealgEmailJsInit = true;
    }
  };

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    initEmailJs();
    if (!window.emailjs) return;
    window.emailjs.sendForm('eal_green', 'contact_us', this).then(
      function () {
        document.getElementById('submitBtn').innerHTML = 'Submitted';
      },
      function (error) {
        console.log('FAILED...', error);
      }
    );
  });

  var select = form.querySelector('[data-ealg-subject]');
  var other = form.querySelector('[data-ealg-other]');
  if (select && other) {
    select.addEventListener('change', function () {
      other.hidden = select.value !== 'Other';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ealg-conversation-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-ealg-conversation-form]');
  if (!form || form.dataset.ealgInit) return;
  form.dataset.ealgInit = 'true';

  var initEmailJs = function () {
    if (window.emailjs && !window.__ealgEmailJsInit) {
      window.emailjs.init('user_4OetZi1NbTB2bj1Ho0j1W');
      window.__ealgEmailJsInit = true;
    }
  };

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    initEmailJs();
    if (!window.emailjs) return;
    window.emailjs.sendForm('eal_green', 'conversation_donor', this).then(
      function () {
        document.getElementById('submitBtn').innerHTML = 'Submitted';
      },
      function (error) {
        console.log('FAILED...', error);
      }
    );
  });

  var select = form.querySelector('[data-ealg-subject]');
  var other = form.querySelector('[data-ealg-other]');
  if (select && other) {
    select.addEventListener('change', function () {
      other.hidden = select.value !== 'Other';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ealg-header"]) return;
  try {
    
(function () {
  var drawer = document.getElementById('ealg-drawer');
  if (!drawer) return;
  var buttons = document.querySelectorAll('[data-ealg-menu-button]');
  var overlay = document.querySelector('[data-ealg-menu-overlay]');
  var toggle = function () {
    var isOpen = !drawer.hidden;
    drawer.hidden = isOpen;
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  };
  buttons.forEach(function (btn) {
    btn.addEventListener('click', toggle);
  });
  if (overlay) overlay.addEventListener('click', toggle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ealg-popup"]) return;
  try {
    
(function () {
  var popup = document.querySelector('[data-ealg-popup]');
  if (!popup) return;

  var KEY = 'ealg-popup-dismissed';
  var stored = null;
  try {
    stored = window.localStorage.getItem(KEY);
  } catch (e) {
    /* storage unavailable — show at most per pageview */
  }

  var posted = popup.querySelector('.ealg-popup__success');
  if (posted) {
    try {
      window.localStorage.setItem(KEY, '1');
    } catch (e) {}
    popup.hidden = false;
    setTimeout(function () {
      popup.hidden = true;
    }, 4000);
    return;
  }

  if (stored) return;

  var shown = false;
  var show = function () {
    if (shown) return;
    shown = true;
    popup.hidden = false;
  };

  document.addEventListener('mouseout', function (event) {
    if (!event.relatedTarget && event.clientY <= 0) show();
  });

  popup.querySelector('[data-ealg-popup-close]').addEventListener('click', function () {
    popup.hidden = true;
    try {
      window.localStorage.setItem(KEY, '1');
    } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ealg-story-impact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var container = document.getElementById('animated-numbers');
  if (!container) return;

  var animationDuration = 2000;
  var frameDuration = 8000 / 60;
  var totalFrames = Math.round(animationDuration / frameDuration);
  var easeOutQuad = function (t) {
    return t * (2 - t);
  };

  var animateCountUp = function (el) {
    var frame = 0;
    var countTo = parseInt(el.innerHTML, 10);
    var counter = setInterval(function () {
      frame++;
      var progress = easeOutQuad(frame / totalFrames);
      var currentCount = Math.round(countTo * progress).toLocaleString();
      if (parseInt(el.innerHTML, 10) !== currentCount) {
        el.innerHTML = currentCount;
      }
      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  };

  var ran = false;
  var runAnimations = function () {
    document.querySelectorAll('.countup').forEach(animateCountUp);
  };

  window.addEventListener('scroll', function () {
    var position = container.getBoundingClientRect();
    if (position.top >= 0 && position.bottom <= window.innerHeight && !ran) {
      runAnimations();
      ran = true;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
